import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";
import styles from "./ScrollIndicator.module.scss";
// @ts-ignore
import { DotLottieReact } from "@lottiefiles/dotlottie-react";

function ScrollIndicator() {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setHidden(true), 3500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <AnimatePresence>
      {!hidden && (
        <motion.div
          className={styles.container}
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.8 }}
        >
          <div>
            <DotLottieReact
              src="https://lottie.host/3a0a8025-c2b6-4391-b280-9713da5d2b65/d64xh9wOrJ.lottie"
              loop
              autoplay
              speed={0.5}
              style={{
                filter: "grayscale(100%) brightness(85%)",
              }}
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default ScrollIndicator;
